

const Title = ({ videoId, title, attributes }) => {

    const { title: titleConfig } = attributes;
    const replacedText = title.replace(/_/g, " ");
    const extractedTitle = replacedText.substring(0, titleConfig?.limit);

    return titleConfig?.show && <div className="videosTitle"><h1><a target={titleConfig.target ? '_blank' : ''} rel="noreferrer" href={`https://www.youtube.com/watch?v=${videoId}`}>{extractedTitle}</a></h1></div>

}
export default Title;